import React from 'react';
import { withRouter } from 'react-router-dom';

class AuthenticationPage extends React.Component {
  componentDidMount() {
    const { history } = this.props;
    const isLoggedIn = localStorage.getItem('amplify-authenticator-authState') === 'signedIn';
    const redirection = localStorage.getItem('pathBeforeSignIn');
    if (isLoggedIn) history.push(!redirection ? '/swap' : redirection);
  }

  render() {
    return <div>Redirecting...</div>;
  }
}

export default withRouter(AuthenticationPage);